import GlobalDialog from 'components/GlobalDialog';
import Loader from 'components/Loader';
import ScrollTop from 'components/ScrollTop';
import AppRoutes from 'routes';
import ThemeCustomization from 'themes';
import useStore from 'zustand-store';

function App() {

  const globalDialog = useStore(state => state.globalDialog);
  const isFetching = useStore(state => state.isFetching);
  const isFetchingWithReplacingView = useStore(state => state.isFetchingWithReplacingView);

  return (
    <ThemeCustomization>
      <ScrollTop>
        <>
          {isFetchingWithReplacingView ? <Loader /> : <AppRoutes />}
          {isFetching && <Loader />}
          <GlobalDialog
            icon={globalDialog.icon}
            isOpen={globalDialog.isOpen}
            title={globalDialog.title}
            description={globalDialog.description}
            actionTitle={globalDialog.actionTitle}
            action={globalDialog.action}
          />
        </>
      </ScrollTop>
    </ThemeCustomization>
  );
}

export default App;
